
<!-- 问卷创建方式页面 -->
<template>
    <div class="create-container">
        <go-back title="返回维普问卷" style="margin: 30px"
                 :before-back="onBeforeBack"/>
        <header class="create-header">选择你要创建的方式</header>
        <el-row type="flex" justify="space-between" class="card--list">
            <el-card
                v-for="item in cardList"
                :key="item.val"
                @click.native.stop="handleCardClick(item)"
                style="height: 253px; width: 32%; cursor: pointer; border-radius: 14px"
                :body-style="bodyStyle">
                <img :alt="item.val" :src="require(`@/assets/img/psq/create/${item.val}.png`)">
                <div class="card--list-item--text">{{item.text}}</div>
                <span>{{item.desc}}</span>
            </el-card>
        </el-row>
        <copy ref="copy"/>
    </div>
</template>

<script>
import Copy from "./cpns/copy"
export default {
    name: "Create",
    components: {
        Copy
    },
    data () {
        return {
            cardList: Object.freeze([
                {
                    text: "空白创建",
                    val: "empty",
                    desc: "从0搭建问卷"
                },
                {
                    text: "文本导入",
                    val: "text",
                    desc: "支持批量导入"
                },
                {
                    text: "复制项目",
                    val: "copy",
                    desc: "复制已创建的项目"
                }
            ])
        }
    },
    computed: {
        // card 内容区域样式
        bodyStyle () {
            return {
                textAlign: "center",
                height: "100%",
                fontSize: "16px",
                padding: "50px",
            }
        },
    },
    methods: {
        handleCardClick (item) {
            if (item.val === "copy") {
                this.$refs.copy.open()
            } else {
                this.$router.push(`/manage/msq/create/${item.val}`)
            }
        },
        onBeforeBack (back) {
            this.$router.replace("/manage/psq")
        }
    }
}
</script>

<style scoped lang="less">
.create-header {
    text-align: center;
    font-weight: 700;
    font-size: 24px;
    margin: 50px 0;
}
.card--list {
    width: 60%;
    margin: 0 auto;
    &-item--text {
        font-weight: 700;
        margin: 30px 0 12px;
    }
}
</style>
